import SetPreferredModal from './SetPreferredModal';

export default SetPreferredModal;
